/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipsSpiHost = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var MembershipsSpiHost = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        MembershipsSpiHost: function () {
            return function (headers) {
                var service = {
                    chargeMembership: function (chargeMembershipRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['serviceProperties', 'scheduledDate'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(chargeMembershipRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/v1/charge-membership', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                    getMembershipVoidability: function (getMembershipVoidabilityRequest) {
                        return httpClient.invoke('POST', '/v1/get-voidability', getMembershipVoidabilityRequest, headers);
                    },
                    listEligibleMemberships: function (listEligibleMembershipsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['lineItems', 'serviceProperties', 'scheduledDate'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(listEligibleMembershipsRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/v1/list-eligible-memberships', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['eligibleMemberships', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['invalidMemberships', 'membership', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    voidMembershipCharge: function (voidMembershipChargeRequest) {
                        return httpClient.invoke('POST', '/v1/void-membership-charge', voidMembershipChargeRequest, headers);
                    },
                };
                service.chargeMembership.__http_method = 'POST';
                service.chargeMembership.__http_url = '/v1/charge-membership';
                service.getMembershipVoidability.__http_method = 'POST';
                service.getMembershipVoidability.__http_url = '/v1/get-voidability';
                service.listEligibleMemberships.__http_method = 'POST';
                service.listEligibleMemberships.__http_url = '/v1/list-eligible-memberships';
                service.voidMembershipCharge.__http_method = 'POST';
                service.voidMembershipCharge.__http_url = '/v1/void-membership-charge';
                return service;
            };
        },
    };
};
exports.MembershipsSpiHost = MembershipsSpiHost;
exports.MembershipsSpiHost.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map